import { render } from "./infoBox.vue?vue&type=template&id=0c72e907&scoped=true"
import script from "./infoBox.vue?vue&type=script&lang=js"
export * from "./infoBox.vue?vue&type=script&lang=js"

import "./infoBox.vue?vue&type=style&index=0&id=0c72e907&scoped=true&lang=css"

import exportComponent from "/Users/robertprikryl/smartAIm/unity_media/vue-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c72e907"]])

export default __exports__